/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * astral/v1/api.proto
 * OpenAPI spec version: version not set
 */

/**
 * The state of an event.

 - STATE_UNSPECIFIED: The state is not specified. This value is not used.
 - STATE_STREAMING: The event fields are being generated by the AI agent. event_data fields may have partial values.
 - STATE_COMPLETE: The event fields are done being generated.
 */
export type V1EventState = (typeof V1EventState)[keyof typeof V1EventState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const V1EventState = {
  STATE_UNSPECIFIED: 'STATE_UNSPECIFIED',
  STATE_STREAMING: 'STATE_STREAMING',
  STATE_COMPLETE: 'STATE_COMPLETE',
} as const;
